module.exports = __webpack_public_path__ + "media/img/praxisnetz-kiel-a51d25de6faafc2ee823cbc37d52570b.jpg";